import React from "react";
import "./DefaultSettingComponent.css";
const DefaultSettingComponent = ({
  handleUpdateSetting,
  formData,
  setFormData,
  errorMessage,
  setErrorMessage,
}) => {
  return (
    <div className="banner_section" style={{ flex: 1 }}>
      <div className="container">
        <div className="defa_setting_hgt">
          <div className="row">
            <div className="col-lg-12 mb_commn_pd_0">
              <div className="default-setting">
                <div className="row justify-content-center">
                  <h4 className="common_heading">Add Setting</h4>
                  <div className="col-lg-12">
                    <form className="form default-setting-form">
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>
                              Default Affiliate Partner Received Money
                            </label>
                            <input
                              className="form-control"
                              value={formData?.DefaultVendorReceivedMoney}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  DefaultVendorReceivedMoney: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  DefaultVendorReceivedMoney: "",
                                });
                              }}
                              type="number"
                              min="1"
                              name="Rmoney"
                              placeholder="2500"
                            />
                          </div>
                          {errorMessage?.DefaultVendorReceivedMoney ? (
                            <div className="validation-message">
                              {errorMessage?.DefaultVendorReceivedMoney}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>Default User Received Money</label>
                            <input
                              value={formData?.DefaultUserReceivedMoney}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  DefaultUserReceivedMoney: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  DefaultUserReceivedMoney: "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="50 point"
                            />
                          </div>
                          {errorMessage?.DefaultUserReceivedMoney ? (
                            <div className="validation-message">
                              {errorMessage?.DefaultUserReceivedMoney}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>
                              Default User Received Lucky Points{" "}
                              <strong>From</strong>
                            </label>
                            <input
                              value={formData?.PointRangeFrom}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  PointRangeFrom: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  PointRangeFrom: "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="Random From Lucky Points"
                            />
                          </div>
                          {errorMessage?.PointRangeFrom ? (
                            <div className="validation-message">
                              {errorMessage?.PointRangeFrom}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>
                              <strong>To</strong>
                            </label>
                            <input
                              value={formData?.PointRangeTo}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  PointRangeTo: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  PointRangeTo: "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              max="99"
                              placeholder="Random To Lucky Points"
                            />
                          </div>
                          {errorMessage?.PointRangeTo ? (
                            <div className="validation-message">
                              {errorMessage?.PointRangeTo}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>
                              Default Convert Affiliate Partner Points In Money
                            </label>
                            <input
                              value={
                                formData?.DefaultConvertVendorPointsInMoney
                              }
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  DefaultConvertVendorPointsInMoney:
                                    e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  DefaultConvertVendorPointsInMoney: "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="1 point=1 Rs"
                            />
                          </div>
                          {errorMessage?.DefaultConvertVendorPointsInMoney ? (
                            <div className="validation-message">
                              {errorMessage?.DefaultConvertVendorPointsInMoney}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>
                              Default User Received Point From Refer
                            </label>
                            <input
                              value={formData?.RewardsPointToReferralUser}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  RewardsPointToReferralUser: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  RewardsPointToReferralUser: "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="Who refer Points Amount"
                            />
                          </div>
                          {errorMessage?.RewardsPointToReferralUser ? (
                            <div className="validation-message">
                              {errorMessage?.RewardsPointToReferralUser}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>
                              Default User Received Point From Refer Claim
                            </label>
                            <input
                              value={formData?.RewardsPointToUser}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  RewardsPointToUser: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  RewardsPointToUser: "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="User will receive Amount"
                            />
                          </div>
                          {errorMessage?.RewardsPointToUser ? (
                            <div className="validation-message">
                              {errorMessage?.RewardsPointToUser}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>Charges For Per View On Banner</label>
                            <input
                              value={formData?.DeductionPerBannerView}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  DeductionPerBannerView: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  DeductionPerBannerView: "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="50/-"
                            />
                          </div>
                          {errorMessage?.DeductionPerBannerView ? (
                            <div className="validation-message">
                              {errorMessage?.DeductionPerBannerView}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>
                              Affiliate Partner Point Bonus (Converting From
                              User To Affiliate Partner)
                            </label>
                            <input
                              value={formData?.VendorCreationBonus}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  VendorCreationBonus: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  VendorCreationBonus: "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="1000/-"
                            />
                          </div>
                          {errorMessage?.VendorCreationBonus ? (
                            <div className="validation-message">
                              {errorMessage?.VendorCreationBonus}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>Bonus Impression While Adding Banner</label>
                            <input
                              value={formData?.BonusBannerImpression}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  BonusBannerImpression: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  BonusBannerImpression: "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="1000/-"
                            />
                          </div>
                          {errorMessage?.BonusBannerImpression ? (
                            <div className="validation-message">
                              {errorMessage?.BonusBannerImpression}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>Promotional Banner Impression Charges</label>
                            <input
                              value={
                                formData?.PromotionalBannerImpressionCharges
                              }
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  PromotionalBannerImpressionCharges:
                                    e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  PromotionalBannerImpressionCharges: "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="10/-"
                            />
                          </div>
                          {errorMessage?.PromotionalBannerImpressionCharges ? (
                            <div className="validation-message">
                              {errorMessage?.PromotionalBannerImpressionCharges}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>
                              Minimum Purchase Amount For Getting Coupon For
                              Special Offer
                            </label>
                            <input
                              value={formData?.MinimumPurchaseAmountForCoupon}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  MinimumPurchaseAmountForCoupon:
                                    e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  MinimumPurchaseAmountForCoupon: "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="10/-"
                            />
                          </div>
                          {errorMessage?.MinimumPurchaseAmountForCoupon ? (
                            <div className="validation-message">
                              {errorMessage?.MinimumPurchaseAmountForCoupon}
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>
                              Minimum Purchase Amount For Default Gift Of
                              Special Offer
                            </label>
                            <input
                              value={
                                formData?.MinimumPurchaseAmountForDefaultGiftOfSpecialOffer
                              }
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  MinimumPurchaseAmountForDefaultGiftOfSpecialOffer:
                                    e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  MinimumPurchaseAmountForDefaultGiftOfSpecialOffer:
                                    "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="300/-"
                            />
                          </div>
                          {errorMessage?.MinimumPurchaseAmountForDefaultGiftOfSpecialOffer ? (
                            <div className="validation-message">
                              {
                                errorMessage?.MinimumPurchaseAmountForDefaultGiftOfSpecialOffer
                              }
                            </div>
                          ) : null}
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="form-group">
                            <label>Delivery Charges</label>
                            <input
                              value={formData?.DeliveryCharges}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  DeliveryCharges: e.target.value,
                                });
                                setErrorMessage({
                                  ...errorMessage,
                                  DeliveryCharges:
                                    "",
                                });
                              }}
                              className="form-control"
                              type="number"
                              min="1"
                              placeholder="300/-"
                            />
                          </div>
                          {errorMessage?.DeliveryCharges ? (
                            <div className="validation-message">
                              {
                                errorMessage?.DeliveryCharges
                              }
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="col-lg-1">
                        <div className="form-group">
                          <button
                            onClick={handleUpdateSetting}
                            type="button"
                            className="btn common_btn view-data-btn w-100"
                          >
                            Update
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="row justify-content-center">
                  <h4 className="common_heading">Your Plans Listing</h4>
                  <div className="col-lg-12">
                    <form className="form default-setting-form">
                      <div className="row">
                        <div className="col-lg-4 col-sm-3">
                          <div className="form-group">
                            <label>Plans Charges</label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Name"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-4">
                          <div className="form-group">
                            <label>Plan Description</label>
                            <input
                              className="form-control"
                              type="text"
                              placeholder="Description"
                            />
                          </div>
                        </div>
                        <div className="col-lg-3 col-sm-3">
                          <div className="form-group">
                            <label>Charges Per View</label>
                            <input
                              className="form-control"
                              type="number"
                              placeholder="50/Banner View"
                            />
                          </div>
                        </div>
                        <div className="col-lg-1 col-sm-2">
                          <div className="form-group">
                            <button
                              type="button"
                              className="common_btn btn-primary btn deflt_add_spc w-100"
                            >
                              Add
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>

                <div className="plans_table-listing">
                  <h4 className="common_heading">Your Plans Listing</h4>
                  <div className="col-lg-12 col-sm-12">
                    <div className="data_not-available_box">
                      <h6>No Plans available.</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DefaultSettingComponent;
